// extracted by mini-css-extract-plugin
export var image = "ZGDr";
export var root = "_7DFZ";
export var table = "table";
export var tableWrapper = "tableWrapper";
export var whytrustus = "whytrustus";